module.exports = __webpack_public_path__ + "static/thumb4-7ef12dd6df1389f29194624e54ee3a84.jpg";